<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div
        v-for="(item, index) of services"
        :key="index"
        class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-5"
        data-aos="flip-left"
      >
        <ServiceCard :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import ServiceCard from './ServiceCard.vue'

export default {
  components: {
    ServiceCard,
  },
  setup() {
    const services = [
      {
        name: 'name-service-one',
        items: [
          {
            es: 'Ofrecemos servicios completos basados en la web y en persona.',
            en: 'We offer complete web-based and in-person',
            pt: 'Oferecemos serviços completos baseados na web e presenciais'
          },
          {
            es: 'Programas de certificación para manipuladores de ganado',
            en: 'Certification programs for livestock handlers',
            pt: 'Programas de certificação para manipuladores de gado'
          },
          {
            es: 'Acceso en línea a materiales y registros.',
            en: 'Online access to materials and records',
            pt: 'Acesso online a materiais e registros'
          },
          {
            es: 'Cuadrilla de captura y transporte',
            en: 'On-farm personnel, loadout crews, and transporter',
            pt: 'Pessoal na fazenda, equipes de carregamento e transportador'
          },
          {
            es: 'Mantenimiento de registros y auditoría de registros',
            en: 'Record keeping and Record auditing',
            pt: 'Manutenção de registros e auditoria de registros'
          },
          {
            es: 'Evaluaciones del sitio productivo',
            en: 'Site assessments',
            pt: 'Avaliações do local'
          },
          {
            es: 'Capacitación para la preparación de auditorías',
            en: 'Audit preparedness training',
            pt: 'Treinamento de preparação para auditoria'
          },
          {
            es: 'Capacitación práctica del personal',
            en: 'Hands-on personnel training',
            pt: 'Treinamento prático de pessoal'
          },
          {
            es: 'Auditorías no anunciadas',
            en: 'Unannounced audits',
            pt: 'Auditorias não anunciadas'
          },
          {
            es: 'Auditorías encubiertas',
            en: 'Undercover audits',
            pt: 'Auditorias secretas'
          },
          {
            es: 'Servicio de auditoria de rescate',
            en: 'Rescue auditing service',
            pt: 'Serviço de auditoria de resgate'
          },
          {
            es: 'Servicio de videoauditoría a distancia',
            en: 'Remote video auditing service',
            pt: 'Serviço de auditoria de vídeo remoto'
          },
          {
            es: 'Verificación de cumplimiento de la propuesta 12 de California',
            en: 'California prop 12 compliance verification',
            pt: 'Verificação de conformidade da prop 12 da Califórnia'
          }
        ],
        photo: 'one'
      },
      {
        name: 'name-service-two',
        items: [
          {
            es: 'Gestión completa del programa',
            en: 'Complete Program management',
            pt: 'Gerenciamento completo do programa'
          },
          {
            es: 'Supervisión remota del programa',
            en: 'Remote program oversight',
            pt: 'Supervisão remota do programa'
          },
          {
            es: 'Planes Robustos de Enfoque Sistemático',
            en: 'Robust Systematic Approach plans',
            pt: 'Planos robustos de abordagem sistemática'
          },
          {
            es: 'Soporte y rescate de expertos en vivo las 24 horas, los 7 días de la semana',
            en: '24/7  live expert support and rescue',
            pt: 'Suporte e resgate especializado ao vivo 24 horas por dia, 7 dias por semana'
          },
          {
            es: 'Informe de incumplimiento (NR) apoyo y respuesta del gobierno (FSIS)',
            en: 'Non-Compliance Report (NR) support and Government (FSIS) response',
            pt: 'Suporte ao Relatório de Não Conformidade (NR) e resposta do Governo (FSIS)'
          },
          {
            es: 'Manejamos todos los programas de capacitación de sus empleados y el mantenimiento de registros.',
            en: 'We handle all your employee training programs and record keeping',
            pt: 'Lidamos com todos os seus programas de treinamento de funcionários e manutenção de registros'
          },
          {
            es: 'Tu equipo de expertos, aquí cuando nos necesites',
            en: 'Your team of experts, here when you need us',
            pt: 'Sua equipe de especialistas, aqui quando você precisar de nós'
          },
          {
            es: 'Entrenamiento de preparación para activistas',
            en: 'Activist preparedness training',
            pt: 'Treinamento de preparação para ativistas'
          }
        ],
        photo: 'two'
      },
      {
        name: 'name-service-three',
        items: [
          {
            es: 'Ofrecemos servicios completos de diseño de instalaciones.',
            en: 'We offer full facility design services',
            pt: 'Oferecemos serviços completos de projeto de instalações'
          },
          {
            es: 'Mejoras a estructuras existentes',
            en: 'Upgrades to existing structures',
            pt: 'Atualizações para estruturas existentes'
          },
          {
            es: 'Complementos',
            en: 'Add ons',
            pt: 'Complementos'
          },
          {
            es: 'Asistencia de conversión de CO2',
            en: 'CO2 conversion assistance',
            pt: 'Assistência de conversão de CO2'
          },
          {
            es: 'Podemos encontrar y ayudarlo a solucionar los problemas de su sistema de insensibilizado, disminuyendo así los problemas de calidad de la carne generados por un mal funcionamiento del equipo',
            en: 'We can find and fix your stunner problems, showing a reduction of meat quality issues from malfunctioning equipment',
            pt: 'Podemos encontrar e corrigir seus problemas de atordoamento, mostrando uma redução dos problemas de qualidade da carne devido ao mau funcionamento do equipamento'
          },
          {
            es: 'Soluciones simples a grandes problemas.',
            en: 'Simple solutions to big problems.',
            pt: 'Soluções simples para grandes problemas.'
          },
        ],
        photo: 'three'
      },
    ]

    return {
      services,
    }
  }
}
</script>

<style scoped>
  .container h3 {
    padding-bottom: 50px;
    text-align: center;
  }
</style>
